import { render } from "./ChatModals.vue?vue&type=template&id=c2aad63e&scoped=true"
import script from "./ChatModals.vue?vue&type=script&lang=js"
export * from "./ChatModals.vue?vue&type=script&lang=js"

import "./ChatModals.vue?vue&type=style&index=0&id=c2aad63e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2aad63e"]])

export default __exports__